exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "creditworthiness-of-loan{border-bottom:1px solid #dddfe2;display:block;padding:0 30px 20px}creditworthiness-of-loan h2{color:#666;font-family:Stag Sans;font-size:16px;line-height:1;margin-bottom:10px;text-align:left}creditworthiness-of-loan .data{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}creditworthiness-of-loan .data .first-column p{color:#666;font-family:Stag Sans;font-size:13px;margin-bottom:5px}creditworthiness-of-loan .data .second-column{text-align:right}creditworthiness-of-loan .data .second-column p{color:#666;font-family:Stag Sans;font-size:14px;margin-bottom:5px;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/creditworthiness/creditworthinessOfLoan/creditworthinessOfLoan.scss
// module id = 1793
// module chunks = 0